import { Button } from '@mui/material'
import Typography from '@mui/material/Typography'
import { FC, useEffect } from 'react'
import { useReplyScheduleDeleteApiV1ReplyScheduleReplyScheduleIdDelete } from '../../api/gen/base'
import { ModalDialogWrapper } from '../../components/ModalDialogWrapper'
import { Notistack } from '../../components/Notistack'

type Props = {
    open: boolean
    replyScheduleId: number | null
    onClose: VoidFunction
    onSuccess?: VoidFunction
}

export const RegularRequestDeleteDialog: FC<Props> = ({
    open,
    onClose,
    onSuccess,
    replyScheduleId,
}) => {
    const { isSuccess, isError, mutate, isPending, reset } =
        useReplyScheduleDeleteApiV1ReplyScheduleReplyScheduleIdDelete()

    const handleDeleteRequest = () => {
        if (replyScheduleId) {
            mutate({ reply_schedule_id: replyScheduleId })
        }
    }

    useEffect(() => {
        if (isSuccess) {
            onSuccess?.()
            onClose?.()
        }
    }, [isSuccess])

    return (
        <>
            <ModalDialogWrapper
                open={open}
                sx={{
                    '.MuiPaper-root': {
                        width: '501px',
                        maxWidth: '501px',
                    },
                }}
                footerActions={
                    <>
                        <Button
                            fullWidth
                            onClick={onClose}
                            variant="outlined"
                            color="primary"
                            disabled={isPending}>
                            Отмена
                        </Button>
                        <Button
                            fullWidth
                            onClick={handleDeleteRequest}
                            color="error"
                            variant="contained"
                            disabled={isPending}>
                            Удалить
                        </Button>
                    </>
                }
                handleClose={onClose}
                title="Удалить регулярный запрос?">
                <Typography variant="body2" color="#1B1C1D">
                    После удаления, запрос и его вложения не будут автоматически отправляться. Вы
                    больше не сможете получать регулярные ответы на запрос
                </Typography>
            </ModalDialogWrapper>
            <Notistack
                isError={isError}
                open={isError || isSuccess}
                message={
                    isError ? 'Ошибка удаления регулярного запроса' : 'Регулярный запрос удален'
                }
                onClose={() => reset()}
            />
        </>
    )
}
